import ItemModelV2 from "../../model2/item2/item-model"
import FieldProto from "./field-proto"
import TasksViewManager from "../../gd-modules/tasks-view/core/manager"
import {ProjectIconCategory} from "../../gd/const/item-icon/project-categories"
import {GoalsIconCategory} from "../../gd/const/item-icon/goals-categories"
import {TaskIconCategory} from "../../gd/const/item-icon/task-categories"
import {IconType} from "../../gd-components/selector/icon-selector/@const"
import {CustomFieldScope} from "../../model2/custom-field/@const"
import GroupBy from "../../gd/manager/group-by/group-by-model"
import ProjectSession from "../../model2/project/project-session"

export enum FieldFilterType {
    DROPDOWN_DYNAMIC    = 'dropdown-dynamic', // use this one when we need options filler - i.e. project filter we need to extract all options from our collection (!)
    DROPDOWN            = 'dropdown',
    STRING              = 'string',
    NUMBER              = 'number',
    MULTISELECT         = 'multiselect',
    BOOLEAN             = 'boolean',
    DATE                = 'date',
    DATERANGE           = 'daterange',
    RATING              = 'rating',
    USER                = 'user',
    RAG                 = 'rag'
}


export type FieldRenderOptions = {

    displayIcon?            : boolean       // used in Schedule eitable - show icons task view mode
}

export type FieldParams = {

    // Date
    highlightIfPastdue?         : boolean

    // Table Cell
    tableCellOnValueChange?     : (item: ItemModelV2, value:any, manager : TasksViewManager ) => void
    tableCellOnAdd?             : {(item: ItemModelV2):void}

    scope?                      : CustomFieldScope[]    // used when we use Field3 as CustomFieldV1 (tasks/projects()

    voteIcon?                   : number    // from All Reactions

    referenceProjectId?         : ID        // from Internal DB field, points to the project to take options from

    columns?                    : any[]     // For "Select field". It's All available fields
    selectedFieldIds?           : ID[]      // For "Select field". It's Selected fields
    canAddNewField?             : boolean   // For "Select field". To show Add field button
    keepPopoverOpenOnSelect?    : boolean   // For "Select field". If true, keeps the popover menu open after selecting an option
    onAddField?                 : callback

    popoverClassName?           : string // is used to set class name for dropdown PopoverMenu

    iconTypes?                  : IconType[]    // used in Icon Generic Field to specify whgichg icon options are availabel like stadard font iicon, emopji, custom url etc.
    iconCategories?             : ProjectIconCategory[] | GoalsIconCategory[] | TaskIconCategory[] // used in Icon Generic Field to specify whgichg icon options are availabel like stadard font iicon, emopji, custom url etc.


    displayName?                : string // Displayed Field label / Field name
}


export type FieldClasses = {
    PopoverContent?             : string
    PopoverMenu?                : string
    PopoverMenuScrollContainer? : string
    inlineValueClass?           : string
}



export type FieldRenderComponents = {
    view                    : any,  // default view
    viewSmall               : any,  // smaller view ... used in glist, etc.

    viewReference           : any,  // used in ItemView when need to specify task/project etc. without editing but with click action as a control button (see fieldType.TASK)
    viewProperty            : any,  // ui5 property i.e. board card, or list project name
    viewGroup               : any   // tasks view group item title view

    // Deprecated ???
    inlineEditable          : any,
    inlineEditableSmall     : any, // like inline editable but got glist/list/table usage

    // Experimental new this is true editable component, with SIZE support, used in inlineEditable and tableEditable etc.,
    // doesnt check access i.e. if u use it it is editable
    editable                : any,

    picker                  : any, // small icon + popover

    formElement             : any,
    formElementView         : any,

    managementPreview       : any, // Custom field settings
    managementForm          : any, // Custom field settings
    managementFormCFV1      : any, // Custom field for tasks and projects (gd.session.customFields)

    quickFilterView         : any,  // Task list left ?
    csvImportPreview        : any,

    // GLIST
    glistView               : any,
    glistEditable           : any,
    glistGroup              : any,

    // TABLE (use either tableCell OR View/Editable?)
    tableCell               : any,  // po hodu this is whole cell
    tableCellCalculated     : any,  // new - used to dispaly calculated values !
    // tableView               : any,  // just content inside table cell view only
    // tableEditable           : any,  // content inside table cell editable
    aggregateCell?          : any   // table (list/gantt in future) last row aggregate values render
    boardAggregate?         : any   // board aggregate values render

    // TASK LIST
    tlistView               : any,
    tlistEditable           : any,

    tlistGroupHeader1        : any   // first level Header for List view group
    tlistGroupHeader2        : any   // second level Header for List view group

    // AUTOMATIONS
    automationTriggerForm   : any,
    automationConditionForm : any,
    automationActionForm    : any,

    conditionForm           : any,
    filterForm              : any,  // used to set filters but same as Condition. just in case leave redefine option

    // GRAPHS
    graphTickLabelView      : any,
    graphTooltipView        : any,

    goalListEditable?       : any
    goalListView?           : any

    controlView?            : any
}


export type FieldComponents = {

    // glist special
    glistGroupModern?       : any,
    glistGroupStandard?     : any,

    // Icon
    ValueIcon?              : any
    ValuePrefix?            : any // is it in use ?

    // inline editable
    InlineValueEmpty?       : any
    InlineValueNotEmpty?    : any

    ListValueEmpty?         : any
    ListValueNotEmpty?      : any

    // dropdown menus
    PopoverMenu?            : any   // I guess popover component used in ??? where ?? PROPS = FieldPopoverMenuProps
    PopoverMenuMore?        : any   // used to help hint etc in popover on the bottiom like edit expense categories, view for etc
    PopoverOption?          : any

    PickerValueEmpty?       : any
    PickerValueNotEmpty?    : any

    FormValueEmpty?         : any   //
    FormValueNotEmpty?      : any
    Pill?                   : any

    // Control view
    ControlViewEmpty?       : any
    ControlViewNotEmpty?    : any

}


export type FieldPopoverProps = {
    parent      : any  //FieldPopover_FormComponent | FieldPopover_InlineEditable, // can be other like inline edit etc.
    field       : FieldProto
    value       : any
    model?      : any
    className?  : string
    disabled?   : boolean
    onChange    : callback,
    targetOffset?   : any,
    options?    : any
};

export type FieldGroupAllPossibleValues_Params = {
    items       : ItemModelV2[],
    groupBy     : GroupBy,
    project?    : ProjectSession
}